<template>
  <router-view />
</template>

<script>
const brandRoutes = ['/', '/login', '/guide', '/terminal', '/info', '/info/data', '/thanks', '/rank', '/signup', '/certificate']

export default {
  watch: {
    '$route.path': {
      immediate: true,
      handler (path) {
        document.body.classList.toggle('joyland-theme', brandRoutes.includes(path === '/' ? '/' : path.replace(/\/$/, '')))
      }
    }
  },
  beforeDestroy () {
    document.body.classList.remove('joyland-theme')
  }
}
</script>

<style>
/* Limit the public-page theme to the five selected routes. */
body.joyland-theme {
  display: flow-root !important;
  height: auto !important;
  min-height: 100vh;

  color: #2e3034;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', sans-serif;
}
body.joyland-theme .ant-layout-footer {
  color: #606670 !important;
}
</style>
